<template>
    <div v-if="scopedProjectData" class="md:max-w-screen-xl w-full mx-auto">
        <div class="my-10 flex flex-wrap px-5">
            <div
                v-if="scopedProjectData.participants.length"
                class="text-4xl font-normal md:flex-nowrap mb-5 md:mb-0 w-full md:w-auto"
            >
                Lista invitați
            </div>
            <div class="grow"></div>
            <div
                v-if="showAddUserButton"
                @click="openAddUserModal()"
                class="btn btn-primary mb-5 md:mr-5 md:mb-0 w-full md:w-auto"
            >
                <font-awesome-icon icon="fa-solid fa-user-plus" /> Adauga
                invitat
            </div>

            <div
                @click="openMigrateUserModal()"
                class="btn btn-primary mb-5 md:mb-0 w-full md:w-auto"
            >
                <font-awesome-icon icon="fa-solid fa-copy" /> Copiaza invitați
            </div>
        </div>

        <table-lite
            v-if="scopedProjectData.participants.length"
            :is-slot-mode="true"
            :is-static-mode="true"
            :is-loading="loading"
            :columns="columns"
            :rows="scopedProjectData.participants"
            :messages="messages"
            :total="scopedProjectData.participants.length"
            :sortable="sortable"
        >
            <template v-slot:recipient_name="data">
                {{ data.value.recipient_name }}
            </template>

            <template v-slot:unique_parameter="data">
                <div class="flex items-center gap-2" style="font-size: 15px;">
                    <a
                        :href="getPersonalURL(data.value)"
                        class="link link-primary text-sm font-semibold"
                        target="_blank"
                    >Link</a>
                    <a
                        href="#"
                        @click.prevent="copyLink(data.value)"
                        class="tooltip text-base-content hover:text-primary transition-colors"
                        data-tip="Copiaza link"
                    >
                        <font-awesome-icon icon="fa-solid fa-copy" />
                    </a>
                    <a
                        v-if="data.value.recipient_mobile"
                        :href="buildWhatsAppLink(data.value)"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="tooltip text-green-500 hover:text-green-600 transition-colors"
                        data-tip="Trimite prin WhatsApp"
                    >
                        <font-awesome-icon icon="fa-brands fa-whatsapp" />
                    </a>
                </div>
            </template>

            <template v-slot:invitation_id="data">
                <div class="flex items-center gap-2">
                    <button
                        @click="openEditModal(data.value)"
                        class="btn btn-square btn-sm btn-outline btn-secondary tooltip"
                        data-tip="Modifica date invitat"
                    >
                        <font-awesome-icon icon="fa-solid fa-user-pen" />
                    </button>
                    <button
                        @click="openResponseModal(data.value)"
                        class="btn btn-square btn-sm btn-outline btn-primary tooltip"
                        data-tip="Adaugă sau modifică răspunsul în numele invitatului"
                    >
                        <font-awesome-icon icon="fa-solid fa-clipboard-check" />
                    </button>
                    <button
                        v-if="data.value.attendance_status && !data.value.form_unlocked"
                        @click="unlockForm(data.value)"
                        class="btn btn-square btn-sm btn-outline btn-warning tooltip"
                        data-tip="Formular blocat — apasă pentru a permite un nou răspuns"
                    >
                        <font-awesome-icon icon="fa-solid fa-lock" />
                    </button>
                    <button
                        v-else-if="data.value.attendance_status && data.value.form_unlocked"
                        class="btn btn-square btn-sm btn-outline border-success text-success no-animation tooltip pointer-events-none"
                        data-tip="Formularul este deblocat — invitatul poate retrimite"
                        tabindex="-1"
                    >
                        <font-awesome-icon icon="fa-solid fa-lock-open" />
                    </button>
                    <button
                        v-else
                        class="btn btn-square btn-sm btn-outline border-base-300 text-base-300 no-animation tooltip pointer-events-none"
                        data-tip="Niciun răspuns încă"
                        tabindex="-1"
                    >
                        <font-awesome-icon icon="fa-solid fa-minus" />
                    </button>
                    <button
                        @click="openDeleteModal(data.value)"
                        class="btn btn-square btn-sm btn-outline btn-accent tooltip"
                        data-tip="Sterge"
                    >
                        <font-awesome-icon icon="fa-solid fa-user-xmark" />
                    </button>
                </div>
            </template>
        </table-lite>

        <p
            v-if="
                scopedProjectData.participants &&
                scopedProjectData.participants.length === 0
            "
            class="text-gray-500 mt-4"
        >
            Nu ai nici un invitat in acest proiect.
        </p>
        <div>
            <ModalComponent
                :is-open="isAddUserModalOpen"
                @close="closeAddUserModal"
            >
                <!-- Content for Modal 1 -->

                <h3 class="font-bold text-lg">Adauga Invitat</h3>
                <AddParticipantForm
                    :projectId="projectId"
                    :close-modal="closeAddUserModal"
                />
                <div class="modal-action">
                    <form method="dialog">
                        <button
                            @click="closeAddUserModal"
                            class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
                        >
                            ✕
                        </button>
                    </form>
                </div>
            </ModalComponent>

            <ModalComponent
                :is-open="isDeleteModalOpen"
                @close="closeDeleteModal"
            >
                <!-- Content for Modal 1 -->

                <h3 class="font-bold text-lg">Sterge Invitat</h3>
                <p class="py-4"></p>
                <p>
                    Urmeaza sa stergi invitatul
                    <span class="font-bold"
                        >{{ selectedDeleteParticipant.recipient_surname }}
                        {{ selectedDeleteParticipant.recipient_name }}</span
                    >.
                </p>
                <p>Aceasta actiune este ireversibila.</p>
                <div class="modal-action">
                    <form method="dialog">
                        <button
                            @click="closeDeleteModal"
                            class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
                        >
                            ✕
                        </button>

                        <button class="btn mr-5" @click="closeDeleteModal">
                            Anuleaza
                        </button>
                        <button
                            @click="
                                deleteParticipant(
                                    selectedDeleteParticipant.unique_parameter
                                )
                            "
                            class="btn btn-accent"
                        >
                            Am inteles, sterge invitatul
                        </button>
                    </form>
                </div>
            </ModalComponent>

            <!-- Add/Edit Modal Content -->
            <ModalComponent :is-open="isEditModalOpen" @close="closeEditModal">
                <h3 class="font-bold text-lg">Modificare Date Invitat</h3>
                <button
                    @click="closeEditModal"
                    class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
                >
                    ✕
                </button>
                <div class="py-4">
                    <div>
                        <label
                            for="editSurname"
                            class="input input-bordered flex items-center gap-2 mb-5"
                            >Nume:<input
                                class="grow"
                                v-model="editedParticipant.recipient_surname"
                                id="editSurname"
                                type="text"
                                required
                        /></label>

                        <label
                            for="editName"
                            class="input input-bordered flex items-center gap-2 mb-5"
                            >Prenume:<input
                                class="grow"
                                v-model="editedParticipant.recipient_name"
                                id="editName"
                                type="text"
                                required
                        /></label>

                        <label
                            for="editMobile"
                            class="input input-bordered flex items-center gap-2 mb-5"
                            >Mobil:
                            <input
                                class="grow"
                                v-model="editedParticipant.recipient_mobile"
                                id="editMobile"
                                type="text"
                                required
                        /></label>

                        <label
                            for="editEmail"
                            class="input input-bordered flex items-center gap-2 mb-5"
                            >Email:
                            <input
                                class="grow"
                                v-model="editedParticipant.recipient_email"
                                id="editEmail"
                                type="email"
                                required
                        /></label>

                        <button
                            class="btn mr-5"
                            @click.prevent="closeEditModal"
                        >
                            Anuleaza
                        </button>
                        <button
                            @click="updateParticipant()"
                            class="btn btn-primary mt-4"
                        >
                            Salveaza
                        </button>
                    </div>
                </div>
            </ModalComponent>

            <!-- Manual Response Modal -->
            <ModalComponent :is-open="isResponseModalOpen" @close="closeResponseModal">
                <h3 class="font-bold text-lg">Răspuns Manual</h3>
                <p class="text-sm text-gray-500 mb-2">
                    Adaugă sau modifică răspunsul în numele invitatului
                    <span class="font-semibold">{{ responseParticipant.recipient_surname }} {{ responseParticipant.recipient_name }}</span>.
                </p>
                <button
                    @click="closeResponseModal"
                    class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
                >
                    ✕
                </button>
                <div class="py-4 space-y-4">
                    <div>
                        <label class="label"><span class="label-text font-semibold">Participare</span></label>
                        <select v-model="responseForm.attendance_status" class="select select-bordered w-full">
                            <option value="Attending">Participă</option>
                            <option value="Not Attending">Nu participă</option>
                        </select>
                    </div>
                    <div class="grid grid-cols-2 gap-4">
                        <div>
                            <label class="label"><span class="label-text font-semibold">Adulți</span></label>
                            <input v-model.number="responseForm.response_adults" type="number" min="0" class="input input-bordered w-full" />
                        </div>
                        <div>
                            <label class="label"><span class="label-text font-semibold">Copii</span></label>
                            <input v-model.number="responseForm.response_children" type="number" min="0" class="input input-bordered w-full" />
                        </div>
                    </div>
                    <div class="grid grid-cols-2 gap-4">
                        <div>
                            <label class="label"><span class="label-text font-semibold">Meniu</span></label>
                            <select v-model="responseForm.response_menu_type" class="select select-bordered w-full">
                                <option value="standard">Standard</option>
                                <option value="vegetarian">Vegetarian</option>
                            </select>
                        </div>
                        <div>
                            <label class="label"><span class="label-text font-semibold">Cazare</span></label>
                            <select v-model="responseForm.response_accommodation" class="select select-bordered w-full">
                                <option :value="0">Nu</option>
                                <option :value="1">Da</option>
                            </select>
                        </div>
                    </div>
                    <div>
                        <label class="label"><span class="label-text font-semibold">Mesaj</span></label>
                        <textarea v-model="responseForm.response_message" class="textarea textarea-bordered w-full" rows="2"></textarea>
                    </div>
                    <div class="flex justify-end gap-3 pt-2">
                        <button class="btn" @click="closeResponseModal">Anulează</button>
                        <button class="btn btn-primary" @click="submitManualResponse()">Salvează răspuns</button>
                    </div>
                </div>
            </ModalComponent>

            <!-- Migrate User Modal Content -->
            <ModalComponent
                v-if="isMigrateUserModalOpen"
                :is-open="isMigrateUserModalOpen"
                @close="closeMigrateUserModal"
            >
                <h3 class="font-bold text-lg">
                    Copiaza invitați din alt proiect
                </h3>
                <button
                    @click="closeMigrateUserModal"
                    class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
                >
                    ✕
                </button>
                <div class="py-4">
                    <MigrateParticipant
                        :projectId="projectId"
                        :close-modal="closeMigrateUserModal"
                    />
                </div>
            </ModalComponent>
        </div>

        <div v-if="loading">
            <LoadingComponent></LoadingComponent>
        </div>
    </div>
</template>

<script>
import TableLite from 'vue3-table-lite';
import ModalComponent from '@/components/ModalComponent.vue';
import LoadingComponent from './LoadingComponent.vue';
import axios from 'axios';
import { useToast } from 'vue-toastification';
import AddParticipantForm from './AddParticipantForm.vue';
import MigrateParticipant from './MigrateParticipant.vue';
import { mapGetters } from 'vuex';

export default {
    props: ['projectId'],
    components: {
        TableLite,
        ModalComponent,
        LoadingComponent,
        AddParticipantForm,
        MigrateParticipant,
    },
    data() {
        return {
            isMigrateUserModalOpen: false,
            isAddUserModalOpen: false,
            isDeleteModalOpen: false,
            selectedDeleteParticipant: {},
            isEditModalOpen: false,
            editedParticipant: {},
            isResponseModalOpen: false,
            responseParticipant: {},
            responseForm: {
                attendance_status: 'Attending',
                response_adults: 1,
                response_children: 0,
                response_menu_type: 'standard',
                response_accommodation: 0,
                response_message: '',
            },
            showAddUserButton: false,
            columns: [
                {
                    label: 'Nume',
                    field: 'recipient_surname',
                    width: '10%',
                    sortable: true,
                },
                {
                    label: 'Prenume',
                    field: 'recipient_name',
                    width: '10%',
                    sortable: true,
                },
                {
                    label: 'Mobil',
                    field: 'recipient_mobile',
                    width: '10%',
                    sortable: false,
                },
                {
                    label: 'Email',
                    field: 'recipient_email',
                    width: '15%',
                    sortable: false,
                },
                {
                    label: 'URL Personal',
                    field: 'unique_parameter',
                    width: '8%',
                    sortable: false,
                },
                {
                    label: 'Actiuni',
                    field: 'invitation_id',
                    width: '14%',
                    sortable: false,
                },
            ],
            sortable: {
                order: 'recipient_name',
                sort: 'desc',
            },
            messages: {
                pagingInfo:
                    'Se afiseaza {0} din {1} rezultate | Total {2} rezultate',
                pageSizeChangeLabel: 'Numar randuri afisate: ',
                gotoPageLabel: ' Mergi la pagina: ',
                noDataAvailable: 'Nu sunt disponibile informatii',
            },
        };
    },
    setup() {
        // Get toast interface
        const toast = useToast();

        // Make it available inside methods
        return { toast };
    },
    mounted() {},
    computed: {
        ...mapGetters([
            'projects',
            'plan',
            'loading',
            'scopedProjectData',
            'stats',
        ]),
    },
    methods: {
        openDeleteModal(participant) {
            this.isDeleteModalOpen = true;
            this.selectedDeleteParticipant = participant;
        },
        closeDeleteModal() {
            this.isDeleteModalOpen = false;
        },
        openAddUserModal() {
            this.isAddUserModalOpen = true;
        },
        closeAddUserModal() {
            this.isAddUserModalOpen = false;
        },
        openMigrateUserModal() {
            this.isMigrateUserModalOpen = true;
        },
        closeMigrateUserModal() {
            this.isMigrateUserModalOpen = false;
        },
        openEditModal(participant) {
            this.isEditModalOpen = true;
            this.editedParticipant = {
                invitation_id: participant.invitation_id,
                project_id: participant.project_id,
                recipient_name: participant.recipient_name,
                recipient_surname: participant.recipient_surname,
                recipient_mobile: participant.recipient_mobile,
                recipient_email: participant.recipient_email,
                unique_parameter: participant.unique_parameter,
            };
        },
        closeEditModal() {
            this.isEditModalOpen = false;
        },
        async updateParticipant() {
            try {
                // Dispatch the 'updateParticipant' action
                await this.$store.dispatch(
                    'updateParticipant',
                    this.editedParticipant
                );
                this.toast.success('Detalii actualizate cu succes!');
                this.closeEditModal();
            } catch (error) {
                this.toast.error(`A aparut o eroare ${error}`);
                // console.error('Error updating participant:', error);
            }
        },
        getBaseURL() {
            const url = new URL(window.location.href);
            return url.origin;
        },
        getPersonalURL(participant) {
            return `${this.getBaseURL()}/#/public/${participant.project_id}/${participant.unique_parameter}`;
        },
        copyLink(participant) {
            const url = this.getPersonalURL(participant);
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(url).then(() => {
                    this.toast.success('Link copiat!');
                });
            } else {
                const el = document.createElement('textarea');
                el.value = url;
                document.body.appendChild(el);
                el.select();
                document.execCommand('copy');
                document.body.removeChild(el);
                this.toast.success('Link copiat!');
            }
        },
        buildWhatsAppLink(participant) {
            const pd = this.scopedProjectData;
            const url = this.getPersonalURL(participant);
            const message = (pd && pd.invitation_message_whatsapp) || (pd && pd.invitation_message) || '';
            const fullMessage = message ? `${message} ${url}` : url;

            let phone = participant.recipient_mobile.replace(/\s+/g, '').replace(/[^0-9+]/g, '');
            if (phone.startsWith('0')) {
                phone = '4' + phone;
            }
            if (!phone.startsWith('+')) {
                phone = '+' + phone;
            }

            return `https://wa.me/${phone}?text=${encodeURIComponent(fullMessage)}`;
        },
        openResponseModal(participant) {
            this.responseParticipant = participant;
            this.responseForm = {
                attendance_status: participant.attendance_status || 'Attending',
                response_adults: participant.response_adults || 1,
                response_children: participant.response_children || 0,
                response_menu_type: participant.response_menu_type || 'standard',
                response_accommodation: participant.response_accommodation || 0,
                response_message: participant.response_message || '',
            };
            this.isResponseModalOpen = true;
        },
        closeResponseModal() {
            this.isResponseModalOpen = false;
        },
        async submitManualResponse() {
            try {
                const jwtToken = localStorage.getItem('userToken');
                const res = await axios.post(
                    '/api/index.php?endpoint=adminUpdateResponse',
                    {
                        project_id: this.responseParticipant.project_id,
                        unique_parameter: this.responseParticipant.unique_parameter,
                        ...this.responseForm,
                    },
                    { headers: { Authorization: `Bearer ${jwtToken}` } }
                );
                if (res.data.success) {
                    this.toast.success('Răspuns salvat cu succes!');
                    this.closeResponseModal();
                    // Refresh participants
                    const projectId = this.projectId;
                    this.$store.dispatch('fetchProjectUsers', { projectId, options: {}, participants: true });
                } else {
                    this.toast.error(res.data.message || 'Eroare la salvarea răspunsului.');
                }
            } catch (e) {
                this.toast.error('Eroare la salvarea răspunsului.');
            }
        },
        async unlockForm(participant) {
            try {
                const jwtToken = localStorage.getItem('userToken');
                const res = await axios.post(
                    '/api/index.php?endpoint=unlockInvitationForm',
                    {
                        project_id: participant.project_id,
                        unique_parameter: participant.unique_parameter,
                    },
                    { headers: { Authorization: `Bearer ${jwtToken}` } }
                );
                if (res.data.success) {
                    this.toast.success(`Formularul pentru ${participant.recipient_surname} ${participant.recipient_name} a fost deblocat.`);
                } else {
                    this.toast.error(res.data.message || 'Eroare la deblocarea formularului.');
                }
            } catch (e) {
                this.toast.error('Eroare la deblocarea formularului.');
            }
        },
        async deleteParticipant(participantId) {
            this.closeDeleteModal();
            const projectId = this.projectId;

            try {
                await this.$store.dispatch('deleteParticipant', {
                    participantId,
                    projectId,
                });

                this.toast.success(
                    `${this.selectedDeleteParticipant.recipient_name} a fost sters din lista de invitați!`
                );
            } catch (error) {
                this.toast.error(
                    `${this.selectedDeleteParticipant.recipient_name} nu a putut fi sters`
                );
            }
        },
    },
};
</script>

<style>
/* Add any styling specific to this component */

.participantsList table {
    border-radius: 20px;
    border: 1px solid #cecece;
}
</style>
